import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Howl, Howler } from 'howler';
import Lottie from 'react-lottie';
import classNames from 'classnames';

import { sceneCount } from '../../shared/constants/constants'
import { setStoryActions, updateCurrentScene } from './story.utils';
import arrow from '../../../assets/lotties/UI/arrow';
import home from '../../../assets/img/home.png';
import styles from './story.module.scss';

export const Story = (props) => {
  const { storyId } = props.location.state;
  const [advanceOption, setAdvanceOption] = useState(false);
  const [scene, setScene] = useState(1);
  const [continueText, setContinueText] = useState(0);
  const [endScreen, setEndScreen] = useState(false);
  let currentScene;
  let storyActions = setStoryActions(storyId);
  let a;

  currentScene = updateCurrentScene(storyId, currentScene, scene);

  function createAudio(assetPath) {
    a = new Howl({
        src: [`/lotties/s${storyId}/${scene}/${assetPath}`],
        volume: 1
    });
    return a;
  }
  
  const defaultOptions = {
    renderer: 'svg',
    loop: false,
    autoplay: true,
    animationData: currentScene,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    },
    audioFactory: createAudio
  };

  const continueArrow = {
    loop: false,
    autoplay: true,
    animationData: arrow,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    }
  };

  useEffect(() => {
    updateCurrentScene(storyId, currentScene, scene);
  }, [scene]);

  return (
    <div>
      <div className={styles.home}>
        <Link onClick={()=> Howler.stop()} to='/home'>
          <img className={styles.homeBtn} height='80px' width='80px' src={home} />
        </Link>
      </div>
        <div className={styles.story}>
            <div>
                <Lottie 
                    options={defaultOptions}
                    eventListeners={[
                        {
                          eventName: 'complete',
                          callback: () => { 
                            scene < sceneCount ? setAdvanceOption(true)
                              : setEndScreen(true);
                          },
                        },
                      ]}
                />
            </div>
        </div>
        {advanceOption ? 
            <div className={styles.continue}>
                <div className={styles.continueContainer}>
                  <button 
                      className={styles.continueBtn}
                      onClick={() => { 
                        setAdvanceOption(false);
                        setContinueText(continueText + 1);
                        scene < sceneCount ? setScene(scene + 1)
                          : setEndScreen(true);
                        }
                      }
                    >
                    <p className={classNames({ [styles.continueText]: storyActions[continueText] })}>
                      {storyActions[continueText]}
                    </p>
                    <div className={styles.arrowBox}><Lottie className={styles.arrow} options={continueArrow} /></div>
                  </button>
                </div>
            </div>
            : <div />
        }
        {endScreen ? 
            <div className={styles.continue}>
                <Link to="/">Return Home</Link>
            </div>
            : <div />
        }
    </div>
  );
};
